import { Component, Renderer2, OnInit } from '@angular/core';
import { ClientService } from '../service/client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../Module/Client.model';
import { NotificationService } from '../service/notification.service';

@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css']
})
export class ClientDetailsComponent implements OnInit {
  clientId!: number;
  client: Client = new Client();
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    private renderer: Renderer2,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'comp-bg');
    this.isLoading = true;

    this.route.queryParams.subscribe(params => {
      this.clientId = +params['id'];
      if (this.clientId) {
        this.loadClient();
      } else {
        this.isLoading = false;
      }
    });
  }

  loadClient(): void {
    this.clientService.getClientById(this.clientId).subscribe({
      next: (data) => {
        this.client = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading client', err);
        this.isLoading = false;
      }
    });
  }

  updateClient(): void {
    this.clientService.updateClient(this.clientId, this.client).subscribe({
      next: () => {
        this.notificationService.show('Client updated successfully');
        this.router.navigate(['/home']);
      },
      error: (err) => {
        console.error('Error updating client', err);
        this.notificationService.show('Failed to update client');
      }
    });
  }
}
